<template>
  <div>
    <h1>Change prices</h1>
    <v-alert :value="true" type="info"
      >Select a quote type below to edit base prices. Also select promotion to
      edit prices for that quote type / promotion. When editing a promotion a
      gray price indicates the base price and a green price indicates that it is
      following the base price. Reset the parameter to follow the base
      price.</v-alert
    >
    <v-select
      v-model="quotetypeid"
      :items="quoteTypes"
      item-value="id"
      label="Select quote type"
      @change="reloadPrice"
      outline
      v-if="quoteTypes"
    >
      <template slot="selection" slot-scope="data"
        >{{ data.item.id }} - {{ data.item.name }}</template
      >
      <template slot="item" slot-scope="data"
        >{{ data.item.id }} - {{ data.item.name }}</template
      >
      <template slot="append-outer" v-if="quotetypeid">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a
              @click="
                quotetypeid = null;
                reloadPrice();
              "
              v-on="on"
            >
              <v-icon>clear</v-icon>
            </a>
          </template>
          <span>Show all quote types</span>
        </v-tooltip>
      </template>
    </v-select>
    <v-select
      v-model="groupid"
      :items="groups"
      item-value="id"
      label="Group"
      @change="reloadPrice"
      outline
      v-if="quotetypeid && groups"
    >
      <template slot="selection" slot-scope="data"
        >{{ data.item.id }} - {{ data.item.name }}</template
      >
      <template slot="item" slot-scope="data"
        >{{ data.item.id }} - {{ data.item.name }}</template
      >
      <template slot="append-outer" v-if="groupid">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a
              @click="
                groupid = null;
                reloadPrice();
              "
              v-on="on"
            >
              <v-icon>clear</v-icon>
            </a>
          </template>
          <span>Show all quote types</span>
        </v-tooltip>
      </template>
    </v-select>
    <v-select
      v-model="promotionid"
      :items="promotions"
      item-value="id"
      label="Select promotion"
      @change="reloadPrice"
      outline
      v-if="promotions"
    >
      <template slot="selection" slot-scope="data"
        >{{ data.item.id }} - {{ data.item.code }} -
        {{ data.item.body }}</template
      >
      <template slot="item" slot-scope="data"
        >{{ data.item.id }} - {{ data.item.code }} -
        {{ data.item.body }}</template
      >
      <template slot="append-outer" v-if="promotionid">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a
              @click="
                promotionid = null;
                reloadPrice();
              "
              v-on="on"
            >
              <v-icon>clear</v-icon>
            </a>
          </template>
          <span>Show all quote types</span>
        </v-tooltip>
      </template>
    </v-select>
    <v-alert :value="true" type="warning" v-if="!groupid"
      >Base prices should not be changed. Group prices are the new base
      prices!</v-alert
    >
    <template v-if="$keycloak.hasRealmRole('root') || groupid">
      <h2>{{ heading }}</h2>
      <div v-if="evaluateQuote">
        <div
          v-for="evaluateCategory in modifiedEvaluateQuote.evaluateCategories"
          :key="evaluateCategory.category.id"
        >
          <div
            v-for="evaluateSection in evaluateCategory.evaluateQuoteScript
              .evaluateSections"
            :key="evaluateSection.section.id"
          >
            <h2>
              {{ evaluateCategory.category.name }}
              {{ evaluateSection.section.xmlTag }}
            </h2>
            <v-select
              label="Track another promotion"
              :value="evaluateSection.promotionid"
              :items="computedPromotionsExclude"
              item-value="id"
              @input="trackPromotion(evaluateSection, $event)"
              v-if="promotionid && computedPromotionsExclude"
              outline
            >
              <template slot="selection" slot-scope="data">
                <span>{{ data.item.code }}</span>
                <span v-if="data.item.entity"
                  >&#160;-&#160;{{ data.item.entity.name }}</span
                >
              </template>
              <template slot="item" slot-scope="data">
                <span>{{ data.item.code }}</span>
                <span v-if="data.item.entity"
                  >&#160;-&#160;{{ data.item.entity.name }}</span
                >
              </template>
              <template slot="append-outer" v-if="evaluateSection.promotionid">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <a @click="trackPromotion(evaluateSection, null)" v-on="on">
                      <v-icon>clear</v-icon>
                    </a>
                  </template>
                  <span>Stop following promotion</span>
                </v-tooltip>
              </template>
            </v-select>
            <div v-if="!evaluateSection.promotionid">
              <div
                v-for="evaluateRuleSet in evaluateSection.evaluateRuleSets"
                :key="evaluateRuleSet.rulesetid"
              >
                <div
                  v-for="evaluateRule in evaluateRuleSet.evaluateRules"
                  :key="evaluateRule.ruleid"
                >
                  <div
                    v-for="evaluateAction in evaluateRule.evaluateActions"
                    :key="evaluateAction.actionid"
                  >
                    <div
                      v-if="
                        evaluateAction.action &&
                        evaluateAction.action.actionType == 'item'
                      "
                    >
                      <v-card
                        v-if="evaluateAction.action.calcType == 'calcFixed'"
                      >
                        <v-card-title class="grey lighten-2" primary-title>
                          <span v-if="evaluateAction.action.description">{{
                            evaluateAction.action.description.body
                          }}</span>
                          <!-- <span>{{action.calcFixed.parameter.name}}</span> -->
                        </v-card-title>
                        <v-card-text>
                          <Parameter
                            :value="
                              evaluateAction.evaluateCalcFixed.evaluateParameter
                            "
                            :groupid="groupid"
                            :promotionid="promotionid"
                            :parameterTypesMap="parameterTypesMap"
                            @updated="update()"
                          />
                        </v-card-text>
                      </v-card>
                      <v-card
                        v-if="evaluateAction.action.calcType == 'calcScaleFee'"
                      >
                        <v-card-title class="grey lighten-2" primary-title>
                          <span v-if="evaluateAction.action.description">{{
                            evaluateAction.action.description.body
                          }}</span>
                        </v-card-title>
                        <v-card-text>
                          <ScaleFee
                            :value="
                              evaluateAction.evaluateCalcScaleFee
                                .evaluateScaleFee
                            "
                            :groupid="groupid"
                            :promotionid="promotionid"
                            :scaleFeeTypesMap="scaleFeeTypesMap"
                            @updated="update()"
                          />
                        </v-card-text>
                      </v-card>
                      <v-card
                        v-if="
                          evaluateAction.action.calcType ==
                          'calcScalePercentage'
                        "
                      >
                        <v-card-title class="grey lighten-2" primary-title>
                          <span v-if="evaluateAction.action.description">{{
                            evaluateAction.action.description.body
                          }}</span>
                        </v-card-title>
                        <v-card-text>
                          <ScalePercentage
                            :value="
                              evaluateAction.evaluateCalcScalePercentage
                                .evaluateScalePercentage
                            "
                            :groupid="groupid"
                            :promotionid="promotionid"
                            :scalePercentageTypesMap="scalePercentageTypesMap"
                            @updated="update()"
                          />
                        </v-card-text>
                      </v-card>
                      <div
                        v-if="evaluateAction.action.calcType == 'calcUser'"
                      ></div>
                      <div
                        v-if="evaluateAction.action.calcType == 'calcMultiply'"
                      >
                        <v-card>
                          <v-card-title class="grey lighten-2" primary-title>
                            <span v-if="evaluateAction.action.description">{{
                              evaluateAction.action.description.body
                            }}</span>
                            <!-- <span>{{action.calcMultiply.parameter.name}}</span> -->
                          </v-card-title>
                          <v-card-text>
                            <Parameter
                              :value="
                                evaluateAction.evaluateCalcMultiply
                                  .evaluateParameter
                              "
                              :groupid="groupid"
                              :promotionid="promotionid"
                              :parameterTypesMap="parameterTypesMap"
                              @updated="update()"
                            />
                          </v-card-text>
                        </v-card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="evaluateQuote && quotetypeid">
        <h2>Discount</h2>
        <v-card>
          <v-card-title class="grey lighten-2" primary-title>
            <span>Discount</span>
          </v-card-title>
          <v-card-text>
            <Parameter
              :value="evaluateQuote.evaluateParameterDiscount"
              :groupid="groupid"
              :promotionid="promotionid"
              :parameterTypesMap="parameterTypesMap"
              @updated="update()"
            />
          </v-card-text>
        </v-card>
        <v-card v-if="quotetypeid == 3">
          <v-card-title class="grey lighten-2" primary-title>
            <span>Sale and Purchase discount</span>
          </v-card-title>
          <v-card-text>
            <Parameter
              :value="evaluateQuote.evaluateParameterDiscountSaleAndPurchase"
              :groupid="groupid"
              :promotionid="promotionid"
              :parameterTypesMap="parameterTypesMap"
              @updated="update()"
            />
          </v-card-text>
        </v-card>
      </div>
    </template>
  </div>
</template>

<script>
import Parameter from "@/components/quote/changePrices/Parameter";
import ScaleFee from "@/components/quote/changePrices/ScaleFee";
import ScalePercentage from "@/components/quote/changePrices/ScalePercentage";
import nbmlaw from "@/api/nbmlaw";
import { convertListOfObjectsToMap } from "@/util/helpers";
export default {
  name: "ChangePrices",
  metaInfo() {
    return {
      title: "Change prices",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { Parameter, ScaleFee, ScalePercentage },
  computed: {
    modifiedEvaluateQuote() {
      if (!this.evaluateQuote) {
        return undefined;
      }
      const evaluateCategories = this.evaluateQuote.evaluateCategories.map(
        (c) => {
          const evaluateSections = c.evaluateQuoteScript.evaluateSections.map(
            (s) => {
              const evaluateRuleSets = s.evaluateRuleSets.map((rs) => {
                const evaluateRules = rs.evaluateRules.map((r) => {
                  const evaluateActions = r.evaluateActions.map((a) => {
                    const action = this.actions
                      ? this.actions[a.actionid]
                      : undefined;
                    const description =
                      action && this.descriptions
                        ? this.descriptions[action.descriptionid]
                        : undefined;
                    return { ...a, action: { ...action, description } };
                  });
                  return { ...r, evaluateActions };
                });
                return { ...rs, evaluateRules };
              });
              return { ...s, evaluateRuleSets };
            }
          );
          const evaluateQuoteScript = {
            ...c.evaluateQuoteScript,
            evaluateSections
          };
          return { ...c, evaluateQuoteScript };
        }
      );
      const evaluateQuote = { ...this.evaluateQuote, evaluateCategories };
      // console.log(evaluateQuote);
      return evaluateQuote;
    },
    parameterTypesMap() {
      return this.parameterTypes
        ? convertListOfObjectsToMap(this.parameterTypes, "id")
        : undefined;
    },
    scaleFeeTypesMap() {
      return this.scaleFeeTypes
        ? convertListOfObjectsToMap(this.scaleFeeTypes, "id")
        : undefined;
    },
    scalePercentageTypesMap() {
      return this.scalePercentageTypes
        ? convertListOfObjectsToMap(this.scalePercentageTypes, "id")
        : undefined;
    },
    computedPromotionsExclude() {
      if (!this.promotionid || !this.computedPromotions) {
        return undefined;
      }
      return this.computedPromotions.filter((p) => p.id != this.promotionid);
    },
    computedPromotions() {
      if (!this.promotions) {
        return undefined;
      }
      return this.promotions.map((p) => {
        const entity = this.entities ? this.entities[p.entityid] : undefined;
        return { ...p, entity };
      });
    },
    computedTrigger() {
      return `${this.$route.query.quotetypeid}-${this.$route.query.groupid}-${this.$route.query.promotionid}`;
    }
  },
  data() {
    return {
      quoteTypes: null,
      groups: null,
      promotions: null,
      entities: null,
      quotetypeid: null,
      groupid: null,
      promotionid: null,
      heading: null,
      evaluateQuote: null,
      actions: null,
      descriptions: null,
      parameterTypes: null,
      scaleFeeTypes: null,
      scalePercentageTypes: null
    };
  },
  methods: {
    async fetchQuoteTypes() {
      const response = await nbmlaw.get(`/cors/admin/sales/quoteTypes`);
      // console.log(response.data);
      this.quoteTypes = response.data;
    },
    async fetchGroups() {
      const response = await nbmlaw.get(`/cors/admin/sales/groups`);
      // console.log(response.data);
      this.groups = response.data;
    },
    async fetchPromotions() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/groups/${this.groupid}/promotions`
      );
      // console.log(response.data);
      this.promotions = response.data;
    },
    async fetchEntities() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/groups/${this.groupid}/promotions/entities`
      );
      // console.log(response.data);
      this.entities = response.data;
    },
    async fetchEvaluateQuote() {
      try {
        const response = await nbmlaw.get(
          `/cors/admin/sales/quoteTypes/${this.quotetypeid}/evaluate`,
          {
            params: {
              groupid: this.groupid,
              promotionid: this.promotionid
            }
          }
        );
        // console.log(response.data);
        this.evaluateQuote = response.data;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchActions() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/quoteTypes/${this.quotetypeid}/evaluate/actions`,
        {
          params: {
            groupid: this.groupid,
            promotionid: this.promotionid
          }
        }
      );
      // console.log(response.data);
      this.actions = response.data;
    },
    async fetchDescriptions() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/quoteTypes/${this.quotetypeid}/evaluate/actions/descriptions`,
        {
          params: {
            groupid: this.groupid,
            promotionid: this.promotionid
          }
        }
      );
      // console.log(response.data);
      this.descriptions = response.data;
    },
    async fetchParameterTypes() {
      const response = await nbmlaw.get(`/cors/admin/sales/parameterTypes`);
      // console.log(response.data);
      this.parameterTypes = response.data;
    },
    async fetchScaleFeeTypes() {
      const response = await nbmlaw.get(`/cors/admin/sales/scaleFeeTypes`);
      // console.log(response.data);
      this.scaleFeeTypes = response.data;
    },
    async fetchScalePercentageTypes() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/scalePercentageTypes`
      );
      // console.log(response.data);
      this.scalePercentageTypes = response.data;
    },
    reloadPrice() {
      if (!this.quotetypeid) {
        this.groupid = null;
      }
      if (!this.groupid) {
        this.promotionid = null;
      }
      this.$router.push({
        name: "changePrices",
        query: {
          quotetypeid: this.quotetypeid,
          groupid: this.groupid,
          promotionid: this.promotionid
        }
      });
    },
    async trackPromotion(evaluateSection, e) {
      await nbmlaw.post(
        `/cors/admin/sales/promotions/${this.promotionid}/link`,
        null,
        {
          params: {
            linkid: e,
            xmlTag: evaluateSection.section.xmlTag
          }
        }
      );
      // console.log(response.data);
      this.update();
    },
    update() {
      this.quotetypeid = this.$route.query.quotetypeid
        ? Number(this.$route.query.quotetypeid)
        : null;
      this.groupid = this.$route.query.groupid
        ? Number(this.$route.query.groupid)
        : null;
      this.promotionid = this.$route.query.promotionid
        ? Number(this.$route.query.promotionid)
        : null;
      if (this.groupid) {
        this.fetchPromotions();
        this.fetchEntities();
      } else {
        this.promotions = null;
        this.entities = null;
      }
      if (this.quotetypeid) {
        this.fetchEvaluateQuote();
        this.fetchActions();
        this.fetchDescriptions();
      }
    }
  },
  watch: {
    computedTrigger: {
      immediate: true,
      handler() {
        this.update();
      }
    }
  },
  created() {
    this.fetchQuoteTypes();
    this.fetchGroups();
    this.fetchParameterTypes();
    this.fetchScaleFeeTypes();
    this.fetchScalePercentageTypes();
  }
};
</script>